export default {
  path: '/fans',
  meta: {
    title: '我的粉丝',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/fans`),
}



// WEBPACK FOOTER //
// ./src/views/Fans/router.js